import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  padding: 15px 30px 0px 30px;
`;

export const Title = styled.h3`
  margin-top: 0px;
  margin-bottom: 10px;
  color: #313638;
  font-size: calc(1.3rem + 0.6vw);
`;

export const SeparatorLine = styled.p`
  padding: 0;
  margin: 0;
  border-bottom: 1px solid #ededed;
  height: 5px;
  width: 99.95%;
`;

export const ButtonForm = styled.button`
  padding: 3px 12px;
  height: 40px;
  border-radius: 4px;
  border: 0px !important;
  width: 200px;
  background-color: #9900ff;
  color: #fff;

  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 16px;
  font-weight: 500;
  font-family: 'Jost', sans-serif;
  line-height: 16px;

  svg {
    font-size: 20px;
    margin-right: 10px;
  }

  margin-right: 8px;
  margin-left: 8px;

  animation: all 0.25s ease-in;

  &:disabled {
    background-color: #b192d1;
    cursor: not-allowed;
    &:hover {
      background-color: #b192d1;
      opacity: 1;
    }
  }

  &:hover {
    opacity: 0.7;
  }

  @media (max-width: 992px) {
    width: 100% !important;
  }
`;
